export function getCurrencySymbol({ locale, currency }: { locale: string; currency: string }) {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(0).replace(/[0-9\s\.,]/g, '');
  } catch (error) {
    console.error('Error getting currency symbol', error);
    console.error(`props: ${JSON.stringify({ locale, currency })}`);
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(0).replace(/[0-9\s\.,]/g, '');
  }
}
